export class DossierNoteModel {
    donId: string ;
    donDossierId :string;
    donLineNumber : number;
    donRoleCodeId : string;
    donNoteTypeId: string;
    donFreeText : string;
    donCreatedBy: string;
    donCreatedDate: Date;
    donLastModifiedBy: string;
    donLastModifiedDate:Date;
    donInactive:boolean;
    actionType: string;
    actionStatus: string;
}